import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
} from "@mui/material";
// import { makeStyles } from "@mui/styles";
import {
    CommonModal,
    InputEmail,
    LoadingButtonV4
} from "../../Common";
import useEmailAlert from "./context/useEmailAlert";
import CustomEmailAlertAutooCompleteField from "./AutoComplete/CustomEmailAlertAutooCompleteField";
import { trakrefFontFamily } from "../../../utils";

/* const useStyles = makeStyles({
    title: {
        color: "#1B2125",
        textAlign: "center",
        fontFamily: "Open Sans",
        fontSize: "22px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "normal"
    },
    email: { marginBottom: "20px", width: "70%" }
}); */

const EmailAlertFormModal = () => {

    const {
        onCloseModal,
        onUpsertAlert,
        openCreateEmail,
        emailAddress,
        modalTitle,
        onFormUpdate,
        selectedEmailAlert,
        isSaving
    } = useEmailAlert();

    const [emailError, setEmailError] = useState(false);
    const [emailAlertsError, setEmailAlertError] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchEmailAlerts, setSearchEmailAlerts] = useState("");
    const [searchRegion, setSearchRegion] = useState("");

    const getSelectedEmailAlerts = () => {
        const data = selectedEmailAlert.map(x => x.emailAlerts).flat().map(x => x.name);
        if (data.length > 0) {
            return `${data[0]} ${data.length > 0 && `+${data.length}`}`;
        }
        return "";
    }

    const closeModal = () => {
        setAnchorEl(null);
        setSearchRegion("");
        setSearchEmailAlerts(getSelectedEmailAlerts());
    }
    
    const submitForm = async () => {

        let hasError = false;

        if (emailAddress.length <= 0) {
            hasError = true;
            setEmailError(true)
        } else {
            setEmailError(false)
        }

        if (selectedEmailAlert.length <= 0) {
            hasError = true;
            setEmailAlertError(true)
        } else {
            setEmailAlertError(false)
        }

        if (hasError)
            return;

        await onUpsertAlert();
    }

    return (
        <CommonModal
            open={openCreateEmail}
            close={onCloseModal}
            width={"499px"}
        >
            <Grid container spacing={3} pt={7} pb={7}>
                <Grid item xs={12} lg={12} align='center'>
                    <Typography
                        variant='h5'
                        align='center'
                        sx={{
                            '&.MuiTypography-root': { fontFamily: trakrefFontFamily },
                            color: "#1B2125",
                            textAlign: "center",
                            fontFamily: "Open Sans",
                            fontSize: "22px",
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "normal"
                        }}
                    >
                        {modalTitle} Email Alert
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={12}
                    align='center'
                    spacing={2}
                >
                    <InputEmail
                        fullWidth
                        label="Email Address"
                        value={emailAddress}
                        onChange={(e) => onFormUpdate('emailAddress', e.target.value)}
                        error={emailError}
                        onFocus={closeModal}
                        sx={{ marginBottom: "20px", width: "70%" }}
                    />
                    <CustomEmailAlertAutooCompleteField
                        emailAlertsError={emailAlertsError}
                        anchorEl={anchorEl} 
                        setAnchorEl={setAnchorEl}
                        searchEmailAlerts={searchEmailAlerts} 
                        setSearchEmailAlerts={setSearchEmailAlerts}
                        closeModal={closeModal}
                        searchRegion={searchRegion} 
                        setSearchRegion={setSearchRegion}
                        getSelectedEmailAlerts={getSelectedEmailAlerts}
                    />
                    <LoadingButtonV4
                        useLargeButton
                        buttonText={`${modalTitle} Email alert`}
                        width={"70"}
                        onClick={submitForm}
                        loading={isSaving}
                        onFocus={closeModal}
                    />
                </Grid>
            </Grid>
        </CommonModal>
    );
}

export default EmailAlertFormModal;